import { useUserStore } from '@/store/userStore';
import { Building2, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface GymSwitcherMenuItemProps {
  onAfterSwitch?: () => void;
}

export const GymSwitcherMenuItem: React.FC<GymSwitcherMenuItemProps> = ({ onAfterSwitch }) => {
  const { gymId, availableGyms, switchGym } = useUserStore();
  const { t } = useTranslation("common");

  if (!availableGyms || availableGyms.length <= 1) return null;

  return (
    <>
      <div className="h-px bg-border my-1" />
      <div className="px-4 py-2">
        <div className="flex items-center gap-2 text-xs font-semibold text-muted-foreground mb-2">
          <Building2 className="h-4 w-4" />
          {t("selectGym", "Salle de sport")}
        </div>
        {availableGyms.map((gym) => (
          <button
            key={gym.id}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              switchGym(gym.id);
              onAfterSwitch?.();
            }}
            className="flex items-center justify-between w-full px-2 py-2 text-sm hover:bg-accent rounded-md transition-colors cursor-pointer"
          >
            <span className="truncate">{gym.name}</span>
            <div className="flex items-center gap-1 flex-shrink-0 ml-2">
              {gym.isPrimary && <span className="text-primary text-xs">⭐</span>}
              {gymId === gym.id && <Check className="h-4 w-4 text-primary" />}
            </div>
          </button>
        ))}
      </div>
    </>
  );
};
